module.exports = __webpack_public_path__ + "img/theCover_04.66f64ac4.jpg";